module.exports = __webpack_public_path__ + "static/media/content-more-thin-24-blue.7e655fff.svg";